<template>
  <div class="w-full px-5">
    <el-row>
      <el-col :xs="24">
        <el-form-item prop="name">
          <label class="text-sm block">Supplier Name:</label>
          <el-input class="w-full" v-model="form.name" type="text"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24">
        <el-form-item prop="supplier_group_id">
          <label class="text-sm block">Supplier Groups:</label>
          <el-select class="w-full" v-model="form.supplier_group_id" multiple placeholder="Please select...">
            <el-option
              v-for="group in groups"
              :key="group.id"
              :label="group.name"
              :value="group.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="email">
          <label class="text-sm block">Supplier Email:</label>
          <el-input class="w-full" v-model="form.email" type="email"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="phone">
          <label class="text-sm block">Supplier Phone:</label>
          <el-input class="w-full" v-model="form.phone" type="phone"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="country_id">
          <label class="text-sm block">Country:</label>
          <el-select class="w-full" v-model="form.country_id" filterable placeholder="Please select..."
                     @change="onGetStates($event)">
            <el-option
              v-for="country in countries"
              :key="country.id"
              :label="country.name"
              :value="country.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="state_id">
          <label class="text-sm block">State:</label>
          <el-select class="w-full" v-model="form.state_id" filterable placeholder="Please select...">
            <el-option
              v-for="state in states"
              :key="state.id"
              :label="state.name"
              :value="state.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="city">
          <label class="text-sm block">City:</label>
          <el-input class="w-full" v-model="form.city" type="text"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="address">
          <label class="text-sm block">Address:</label>
          <el-input class="w-full" v-model="form.address" type="text"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mb-4">
      <el-form-item prop="contact_person">
        <el-col :xs="24">
          <label class="text-sm block">Contact Person Name:</label>
          <el-input class="w-full" v-model="form.contact_person" type="text"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-form-item prop="status">
        <el-col :xs="24">
          <label class="text-sm block">Enable</label>
          <el-switch v-model="form.status"></el-switch>
        </el-col>
      </el-form-item>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'SuppliersForm',
  props: ['form'],
  data() {
    return {};
  },
  computed: {
    countries() {
      return this.$store.state.SettingsModule.Location.countries.data;
    },
    states() {
      return this.$store.state.SettingsModule.Location.states;
    },
    cities() {
      return this.$store.state.SettingsModule.Location.cities;
    },
    groups() {
      return this.$store.state.InventoryModule.SuppliersGroup.suppliers_groups;
    },
  },
  async mounted() {
    const page = 1; const limit = 1000;
    try {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCountries', { page, limit });
      await this.$store.dispatch('InventoryModule/SuppliersGroup/fetchAllSuppliersGroups');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    async onGetStates(countryId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId });
    },
    async onGetCities(stateId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCities', { stateId });
    },
  },
};
</script>

<style scoped>

</style>
